export const studyCompletionFormConfig = [
  {
    // section: "Study Completion / Termination Record",
    folders: [
      {
        name: "study completion",
        icon: "fa fa-check-square-o",
        color: "#4CAF50",
        description: "Initial assessment and data collection for the study",
        title: "Study Completion",
        subTitle: "Initial assessment and data collection",
        fields: [
          {
            title: "Did the Subject complete the study?",
            name: "studyComplete",
            description: "Mark Yes if the subject completed the study, No otherwise.",
            type: "radio",
            options: ["Yes", "No"],
            required: true
          },
          {
            title: "Provide comments",
            name: "studyComments",
            description: "Comments if subject did not complete the study",
            type: "textarea",
            showIf: {
              field: "studyComplete",
              value: "No"
            },
            required: false
          },
          {
            title: "Date of Study Completion",
            name: "completionDate",
            description: "The date when the subject completed the study",
            type: "date",
            showIf: {
              field: "studyComplete",
              // value: "Yes"
            },
            required: true
          },
          {
            title: "The Date of Study Discontinuation or Screen Failure:",
            name: "discontinuationDate",
            description: "The date when the subject discontinued the study",
            type: "date",
            showIf: {
              field: "studyComplete",
              value: "No"
            },
            required: true
          },
          {
            title: "Study Completion Certificate",
            name: "completionCertificate",
            description: "Upload the study completion certificate",
            type: "text",
            attachmentRequired: true,
            required: true
          }
        ]
      },
      {
        name: "reason for discontinuation",
        icon: "fa fa-times-circle",
        color: "#E53935",
        description: "Capture reason for discontinuing the study",
        title: "Reason for Discontinuation",
        subTitle: "Details of discontinuation reason",
        fields: [
          {
            title: "Reason for Discontinuation",
            name: "discontinuationReason",
            type: "select",
            options: [
              "Adverse Event",
              "Protocol Deviation",
              "Withdrawal of Consent",
              "Lost to Follow-up",
              "Death"
            ],
            required: true
          },
          {
            title: "Comments / Cause of Death",
            name: "discontinuationComments",
            type: "textarea",
            showIf: {
              field: "discontinuationReason",
              value: "Death"
            },
            required: true
          },
          {
            title: "Date of Death",
            name: "dateOfDeath",
            type: "date",
            showIf: {
              field: "discontinuationReason",
              value: "Death"
            },
            required: true
          },
          {
            title: "Supporting Documentation",
            name: "supportingDocs",
            description: "Upload any supporting documentation for discontinuation",
            type: "textarea",
            attachmentRequired: true,
            required: false
          }
        ]
      }
    ]
  }
];
